import type { LucideIcon } from 'lucide-react'
import { FileText, Clock, CheckCircle2, AlertTriangle, Calendar, ListChecks } from 'lucide-react'
import { PublicationMetrics } from '@/types/publication'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/utils/cn'
import { PainelTone, painelToneClass } from './PainelCard'

interface MetricsCardsProps {
  metrics: PublicationMetrics
}

interface MetricCardProps {
  label: string
  value: number
  icon: LucideIcon
  tone?: PainelTone
}

function MetricCard({ label, value, icon: Icon, tone = 'default' }: MetricCardProps) {
  return (
    <Card size="sm">
      <CardContent className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-muted-foreground">{label}</p>
          <p className={cn('text-2xl font-semibold tabular-nums', painelToneClass[tone])}>{value}</p>
        </div>
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted">
          <Icon className="size-5 text-muted-foreground" aria-hidden="true" />
        </div>
      </CardContent>
    </Card>
  )
}

export function MetricsCards({ metrics }: MetricsCardsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      <MetricCard label="Total" value={metrics.total} icon={FileText} />
      <MetricCard label="Pendentes" value={metrics.pending} icon={Clock} tone="destructive" />
      <MetricCard label="Relevantes" value={metrics.relevant} icon={CheckCircle2} tone="primary" />
      <MetricCard label="Urgentes" value={metrics.urgent} icon={AlertTriangle} tone="destructive" />
      <MetricCard label="Esta Semana" value={metrics.thisWeek} icon={Calendar} />
      <MetricCard label="Com Tarefas" value={metrics.withTasks} icon={ListChecks} tone="primary" />
    </div>
  )
}
